export default __webpack_public_path__ + "static/media/InHonor.f132660d.png";